import { ComponentProps, createMemo } from "solid-js";
import c from "class-c";

import createId from "@repo/signals/createId";
import UObject from "@repo/utils/UObject";

import Input from "./Input";

import styles from "./Checkbox.module.scss";

declare namespace Checkbox {
  type Props = Omit<ComponentProps<"input">, "type" | "required"> &
    ({ errored?: boolean } | { required?: boolean });
}

function Checkbox({
  class: className,
  id: _id = createId(),
  ...props
}: D<Checkbox.Props>) {
  const id = createMemo(() => _id);
  return (
    <div
      class={c`
        ${c(styles)`
          checkbox
          ${UObject.pick(props, ["errored", "required"])}
        `}
        ${className}
      `}
    >
      <input type="checkbox" {...props} id={id()} />
      <label for={id()}>
        <div class={`${styles.check} text:++`}></div>
      </label>
    </div>
  );
}

declare namespace Checkbox.WithLabel {
  type Props = Checkbox.Props & {
    error?: Input.Error;
  };
}
Checkbox.WithLabel = ({
  id: _id = createId(),
  class: className,
  children,
  error,
  ...props
}: D<Checkbox.WithLabel.Props>) => {
  const id = createMemo(() => _id);
  return (
    <div class={c`${styles["with-label"]} ${className}`}>
      <div>
        <Checkbox
          id={id()}
          {...props}
          errored={"errored" in props ? props.errored : !!error}
        />
        <label for={id()}>{children}</label>
      </div>
      <Input.Error>{error}</Input.Error>
    </div>
  );
};

export default Checkbox;
